/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react'

import { LoginFormContent } from '@ally/ally-login'
import { useTransmit } from '../../TransmitContext'
import { useOptionalRedirectPathValue } from '../../RedirectContext'
import { useHostServices } from '../../HostServices'

export const LoginWrapper: React.FC = () => {
  const {
    activeScreen,
    actions,
    isInPortal = false,
    navigateToForgotPassword,
    navigateToForgotUsername,
    navigateToOleCustomer,
    cancelButton,
    logger,
    hostServices,
  } = useTransmit()
  const maybeRedirectContext = useOptionalRedirectPathValue()
  const { featureFlags } = useHostServices()

  return (
    <LoginFormContent
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(activeScreen.type === 'Password' ? activeScreen.payload : {})}
      actions={actions}
      cancelButton={cancelButton}
      hostServices={hostServices}
      isInPortal={isInPortal}
      logger={logger}
      maybeRedirectContext={maybeRedirectContext}
      navigateToForgotPassword={navigateToForgotPassword}
      navigateToForgotUsername={navigateToForgotUsername}
      navigateToOleCustomer={navigateToOleCustomer}
      variation={featureFlags.variation}
    />
  )
}
